// @flow

export { InputArgentineDocument } from './input-argentine-document';
export { InputArgentineDocumentType } from './input-argentine-document-type';
export { InputArgentinePhoneNumber } from './input-argentine-phone-number';
export { InputArgentineZipcode } from './input-argentine-zipcode';
